import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { HowToReg, PersonOff } from "@mui/icons-material";

const PresentDetail1Widget = ({ widget, onValueUpdate }) => {
  const [isPresent, setIsPresent] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsPresent(widget.items.$w1.value === "present");
    }
  }, [widget]);

  const getStatusText = () => {
    return isPresent ? "present" : "clear";
  };

  const getPresenceIcon = () => {
    return isPresent ? (
      <HowToReg style={{ fontSize: "1.5rem", color: "white" }} />
    ) : (
      <PersonOff style={{ fontSize: "1.5rem", color: "white" }} />
    );
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Presence Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "40px",
          backgroundColor: "hsl(var(--primary))",
          opacity: isPresent ? 1 : 0.2,
        }}
      >
        <Typography className="text-white font-bold capitalize">
          {getStatusText()}
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          {getPresenceIcon()}
        </div>
      </div>
    </div>
  );
};

export default PresentDetail1Widget;
